module.exports = __webpack_public_path__ + "img/bluebear.bdc02166.gif";